import React from 'react';
import { observer } from 'mobx-react';

import { AdvanceTable, IconTextButton } from 'ui-lib';

import { useAccountStore, useAuthStore } from '../../../store';
import { IAccount, AccountType } from '../../../dto/access-management/account-dto';
import { OrganisationSelect } from '../components/organisation-select';
import { useAccountTreeSelectDataSource } from '../admin/accounts';
import { KcvVerificationTable } from './kcv-table';

enum KCV_KEYS_STATE {
    CLIENTS = 'clients',
    KCV_INFORMATION = 'kcvInfo',
}

export const KcvPspKeyPage = observer(() => {
    const { currentUser } = useAuthStore();
    const accountStore = useAccountStore();
    const varAccountSource = useAccountTreeSelectDataSource({
        viewableTypes: [AccountType.DPU, AccountType.VAR],
        selectableTypes: [AccountType.VAR],
    });
    const [displayState, setDisplayState] = React.useState<KCV_KEYS_STATE>(KCV_KEYS_STATE.CLIENTS);
    const [selectedClientId, setSelectedClientId] = React.useState<number>();
    const [clientSource, setClientSource] = React.useState<IAccount[]>([]);

    React.useEffect(() => {
        let accountId: number;
        switch (currentUser.accountType) {
            case AccountType.VAR:
                accountId = currentUser.accountId;
                break;
            case AccountType.CLIENT: {
                accountId = currentUser.accountId;
                break;
            }
            case AccountType.DPU:
            default:
                accountId = null;
                break;
        }

        setClientSource(accountStore.getClientsForAccount(accountId));
    }, []);

    const organisationChangeHandler = (value) => {
        setDisplayState(KCV_KEYS_STATE.CLIENTS);
        setClientSource(accountStore.getClientsForAccount(value));
    };

    const onClientSelect = (record: IAccount) => {
        setSelectedClientId(record.id);
        setDisplayState(KCV_KEYS_STATE.KCV_INFORMATION);
    };

    return (
        <div>
            {currentUser.accountType === AccountType.DPU && (
                <OrganisationSelect
                    treeDataSource={varAccountSource}
                    onChange={organisationChangeHandler}
                    expandAll={true}
                    disabled={accountStore.dataLoading}
                />
            )}
            {displayState === KCV_KEYS_STATE.CLIENTS && (
                <AdvanceTable
                    loadingState={accountStore.dataLoading}
                    title={''}
                    table={{
                        rowKey: 'id',
                        columns: [
                            {
                                code: 'name',
                                title: 'Client Name',
                                dataIndex: 'name',
                                render: (text: string, record: any) => (
                                    <IconTextButton
                                        type='link'
                                        htmlType='button'
                                        onClick={() => onClientSelect(record)}
                                        label={text}
                                    />
                                ),
                            },
                        ],
                        dataSource: clientSource,
                    }}
                />
            )}
            {displayState === KCV_KEYS_STATE.KCV_INFORMATION && (
                <KcvVerificationTable
                    clientAccountId={selectedClientId}
                    onBack={() => setDisplayState(KCV_KEYS_STATE.CLIENTS)}
                />
            )}
        </div>
    );
});
